import { TaskPriority } from '../types/Task';
import { getTaskPriorityLabel, getTaskPriorityValue } from '../utils/taskPriority';

interface PriorityBadgeProps {
  priority?: TaskPriority;
}

export const PriorityBadge: React.FC<PriorityBadgeProps> = ({ priority }) => {
  const priorityValue = getTaskPriorityValue(priority);

  return (
    <span className={`priority-badge priority-${priorityValue.toLowerCase()}`}>
      {getTaskPriorityLabel(priorityValue)}
    </span>
  );
};
